import React from 'react';
import CaseDownList from "../../components/CaseDown/CaseDownList";

const CaseDownPage = () => {

    return (
        <CaseDownList />
    );
};

export default CaseDownPage;